<script setup>
import {computed} from "vue";
import {HpoRole, HpoRoleLabel} from "../hpo/choices";
import {SwitchHpoMemberRoleMutation} from "@/graphql/mutations/hpo/member.graphql";
import {useMutation} from "@vue/apollo-composable";
import {currentUser} from "@/infrastructure/user";

const props = defineProps({
    hpoMember: {
        type: Object,
        required: false,
        default: undefined
    },
})

const {mutate, loading} = useMutation(SwitchHpoMemberRoleMutation)

const selectedHpoRole = computed({
    get() {
        return props.hpoMember.role
    },
    set(value) {
        mutate({
            memberRole: value,
            memberId: props.hpoMember.id,
        }).then(result => {
            location.reload()
        }).catch((error) => {
            console.log(error)
        })
    }
})

const selectChoices = computed(() => {
    if (props.hpoMember) {
        if (currentUser.isSuperuser) {
            return Object.values(HpoRole).map(value => ({value, title: HpoRoleLabel[value]}))
        }
        if ([HpoRole.PHC, HpoRole.EVAC_MANAGER].includes(props.hpoMember.role)) {
            return [
                {value: HpoRole.PHC, title: HpoRoleLabel[HpoRole.PHC]},
                {value: HpoRole.EVAC_MANAGER, title: HpoRoleLabel[HpoRole.EVAC_MANAGER]}
            ]
        }
        return [{value: props.hpoMember.role, title: HpoRoleLabel[props.hpoMember.role]}]
    }
    return []
})


</script>

<template>
    <v-select v-model="selectedHpoRole"
              :disabled="selectChoices.length<2"
              :loading="loading"
              max-width="300px"
              :label="pgettext('label', 'User role')"
              :items="selectChoices"
              hide-details
              variant="filled"
    ></v-select>
</template>